//Production

import axios from "axios";
import { refreshHeaderOptionToken } from "../utils/apis/api-header-option";
import { setItemWithObject } from "../utils/cache/LocalStorage";
import { encryptedAPINames, pemPublicKey } from "../constants/index";
import { encryptPayload } from "encrypt-with-rsa-and-aes";


const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
// const apiBaseURL = "https://prodapi.betasendapp.com/"


export const getObj = (url: string, type: string, id: any) => {
  let headers = refreshHeaderOptionToken();

  let tempURL =
    type === "user"
      ? apiBaseURL + "user/api"
      : type === "provider"
      ? apiBaseURL + "serviceprovider/api"
      : apiBaseURL + "order/api";

  let URL = `${tempURL}/${url}` + id;
  let URLs = URL.replace('"', "");
  let fId = URLs.replace('"', "");

  return axios(fId, {
    method: "GET",
    headers: headers.option,
  });
};

export const GET = async (url: string, type: string, option = "") => {
  let headers = refreshHeaderOptionToken();

  let tempURL = "";
  switch (type) {
    case "user": {
      tempURL = apiBaseURL + "user/api";
      break;
    }
    case "courier": {
      tempURL = apiBaseURL + "courier/api";
      break;
    }
    case "provider": {
      tempURL = apiBaseURL + "serviceprovider/api";
      break;
    }
    case "order": {
      tempURL = apiBaseURL + "order/api";
      break;
    }
    case "chat": {
      tempURL = apiBaseURL + "chat/api";
      break;
    }
    case "refer": {
      tempURL = apiBaseURL + "refer/api";
      break;
    }

    case "admin": {
      tempURL = apiBaseURL + "admin/api";
      break;
    }

    case "loan": {
      tempURL = apiBaseURL + "payment/api";
      break;
    }

    case "live": {
      tempURL = apiBaseURL + "livehosting/api";
      break;
    }

    default: {
      tempURL = "";
      break;
    }
  }

  try {
    const response = await axios.get(`${tempURL}/${url}`, {
      method: "GET",
      headers: option === "optionPlane" ? headers.optionPlane : headers.option,
    });
    return response;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      //alertMessage(ALERT_TITLES.ERROR, "Session Expired.");
    } else
      return {
        status: error?.response?.status || 400,
        message: error?.response?.data || "Something went wrong",
      };
  }
};

export function getImageURL(url: any): any {
  fetch(`${url}`)
    .then((res) => res.json())
    .catch((err) => {
      return null;
    })
    .then((json) => {
      return json;
    });
}

export function getDataServiceMenus(
  url: string,
  type: string,
  option = "optionPlane"
): any {
  let headers = refreshHeaderOptionToken();

  let tempURL =
    type === "user"
      ? apiBaseURL + "user/api"
      : type === "provider"
      ? apiBaseURL + "serviceprovider/api"
      : apiBaseURL + "order/api";

  return axios(`${tempURL}/${url}`, {
    method: "GET",
    headers: option === "optionPlane" ? headers.optionPlane : headers.option,
  });
}

export const POST = async (url: string, data: any, type: string,noToken : boolean = false,token : any = null) => {

  
  let index = encryptedAPINames.findIndex(
    (e: any) =>
      e.value.trim().toLowerCase() ===
      url.split("/").pop()?.trim().toLowerCase()
  );

  let headers = refreshHeaderOptionToken();

  const typeToBaseURL: Record<string, string> = {
    user: `${apiBaseURL}user/api`,
    provider: `${apiBaseURL}serviceprovider/api`,
    order: `${apiBaseURL}order/api`,
    admin: `${apiBaseURL}admin/api`,
    chat: `${apiBaseURL}chat/api`,
    payment: `${apiBaseURL}payment/api`,
    live: `${apiBaseURL}livehosting/api`,
  };

  const tempURL = typeToBaseURL[type] || "";

  let param;
  if (index > -1) {
    try {
      // Ensure data is an object before encryption
      const dataToEncrypt = typeof data === 'string' ? JSON.parse(data) : data;
      const payLoad = await encryptPayload(dataToEncrypt, pemPublicKey);
      param = { payload: payLoad };
    } catch (error) {
      console.error("Encryption failed:", error);
      // Fall back to unencrypted if encryption fails
      param = data;
      console.warn("Falling back to unencrypted data due to encryption error");
    }
  } else {
    param = data;
  }

  try {
    let updatedURL = type === "kyb"? url : (tempURL +"/"+ url);
    const response = await axios.post(updatedURL, param, {
      headers: noToken ? headers.optionPlane : (!token ? headers.option : {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    }),
    });
    return response;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      //
      // alertMessage(ALERT_TITLES.ERROR, "Session Expired.");
    } else
      return {
        status: error?.response?.status || 400,
        message: error?.response?.data || "Something went wrong",
      };
  }
};

export const UserSignup = async (url: string, data: any) => {
  let headers = refreshHeaderOptionToken();

  axios
    .post(`${apiBaseURL}/user/api/${url}`, data, headers.optionPlane)
    .then(function (response) {
      setItemWithObject("response", { status: "success", response: response });
    })
    .catch(function (error) {
      setItemWithObject("response", {
        status: "error",
        response: error.response,
        code: error?.response?.status,
      });
    });
};

export const UserLogin = (url: string, data: any) => {
  let headers = refreshHeaderOptionToken();

  axios
    .post(`${apiBaseURL}/user/api/${url}`, data, headers.optionPlane)
    .then(function (response) {
      setItemWithObject("response", { status: "success", response: response });
    })
    .catch(function (error) {
      setItemWithObject("response", {
        status: "error",
        response: error.response,
        code: error?.response?.status,
      });
    });
};

export const PUT = (url: string, data: any, type: string) => {
  let headers = refreshHeaderOptionToken();

  let tempURL =
    type === "user"
      ? apiBaseURL + "user/api"
      : type === "provider"
      ? apiBaseURL + "serviceprovider/api"
      : apiBaseURL + "order/api";

  return axios(`${tempURL}/${url}`, {
    method: "PUT",
    headers: headers.option,
    data,
  });
};

export const DELETE = (url: string, data: any, type: string) => {
  let headers = refreshHeaderOptionToken();

  let tempURL =
    type === "user"
      ? apiBaseURL + "user/api"
      : type === "provider"
      ? apiBaseURL + "serviceprovider/api"
      : apiBaseURL + "order/api";
  return axios(`${tempURL}/${url}`, {
    method: "DELETE",
    headers: headers.option,
    data,
  });
};


//uat
// import axios from "axios";
// import { refreshHeaderOptionToken } from "../apis/api-header-option";
// import { setItemWithObject } from "../auth/LocalStorage";
// import { encryptedAPINames, pemPublicKey } from "../constants";
// import { encryptPayload } from "encrypt-with-rsa-and-aes";
// import Swal from "sweetalert2";


// const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

// export const getObj = (url: string, type: string, id: any) => {
//   let headers = refreshHeaderOptionToken();

//   let tempURL =
//     type === "user"
//       ? apiBaseURL + "user"
//       : type === "provider"
//       ? apiBaseURL + "serviceprovider"
//       : apiBaseURL + "order";

//   let URL = `${tempURL}/${url}` + id;
//   let URLs = URL.replace('"', "");
//   let fId = URLs.replace('"', "");

//   return axios(fId, {
//     method: "GET",
//     headers: headers.option,
//   });
// };

// export const postPC = (url: string, param: any) => {
//   let headers = refreshHeaderOptionToken();

//   axios
//     .post(url, param, {
//       headers: headers.option,
//     })
//     .then(({ data }) => {
//       return { status: 200, res: data };
//     })
//     .catch((error) => {
//       if (error?.response?.status && error?.response?.status === 401) {
//         return { status: 401, res: null };
//       } else {
//         return { status: 400, res: error?.response?.data };
//       }
//     });
// };

// export const GET = async (url: string, type: string, option = "") => {
//   let headers = refreshHeaderOptionToken();

//   let tempURL = "";
//   switch (type) {
//     case "user": {
//       tempURL = apiBaseURL + "user";
//       break;
//     }
//     case "courier": {
//       tempURL = apiBaseURL + "courier";
//       break;
//     }
//     case "provider": {
//       tempURL = apiBaseURL + "serviceprovider";
//       break;
//     }
//     case "order": {
//       tempURL = apiBaseURL + "order";
//       break;
//     }
//     case "chat": {
//       tempURL = apiBaseURL + "chat";
//       break;
//     }
//     case "refer": {
//       tempURL = apiBaseURL + "refer";
//       break;
//     }

//     case "admin": {
//       tempURL = apiBaseURL + "admin";
//       break;
//     }

//     case "loan": {
//       tempURL = apiBaseURL + "payment";
//       break;
//     }

//     case "live": {
//       tempURL = apiBaseURL + "livehosting";
//       break;
//     }

//     default: {
//       tempURL = "";
//       break;
//     }
//   }

//     try {
//     const response = await axios.get(`${tempURL}/${url}`, {
//       method: "GET",
//       headers: option === "optionPlane" ? headers.optionPlane : headers.option,
//     });
//     return response;
//   } catch (error: any) {
//     if (error?.response?.status === 401) {
//       alertMessage(ALERT_TITLES.ERROR, "Session Expired.");
//     } else
//       return {
//         status: error?.response?.status || 400,
//         message: error?.response?.data || "Something went wrong",
//       };
//   }
// };

// export function getImageURL(url: any): any {
//   fetch(`${url}`)
//     .then((res) => res.json())
//     .catch((err) => {
//       return null;
//     })
//     .then((json) => {
//       return json;
//     });
// }

// export async function getDataServiceMenus(
//   url: string,
//   type: string,
//   option = "optionPlane"
// ): Promise<any> {
//   let headers = refreshHeaderOptionToken();

//   let tempURL =
//     type === "user"
//       ? apiBaseURL + "user"
//       : type === "provider"
//       ? apiBaseURL + "serviceprovider"
//       : apiBaseURL + "order";

//   // return axios(`${tempURL}/${url}`, {
//   //   method: "GET",
//   //   headers: option === "optionPlane" ? headers.optionPlane : headers.option,
//   // });

//   try {
//     const response = await axios.get(`${tempURL}/${url}`, {
//       method: "GET",
//       headers: option === "optionPlane" ? headers.optionPlane : headers.option,
//     });
//     return response;
//   } catch (error: any) {
//     if (error?.response?.status && error?.response?.status === 401) {
//       alertMessage(ALERT_TITLES.ERROR, "Session Expired.");
//     } else {
//       return {
//         status: error?.response?.status || 400,
//         message: error?.response?.data || "Something went wrong",
//       };
//     }
//   }
// }

// export const POST = async (url: string, data: any, type: string) => {
//   let index = encryptedAPINames.findIndex(
//     (e: any) =>
//       e.value.trim().toLowerCase() ===
//       url.split("/").pop()?.trim().toLowerCase()
//   );

//   let headers = refreshHeaderOptionToken();

//   const typeToBaseURL: Record<string, string> = {
//     user: `${apiBaseURL}user`,
//     provider: `${apiBaseURL}serviceprovider`,
//     order: `${apiBaseURL}order`,
//     admin: `${apiBaseURL}admin`,
//     chat: `${apiBaseURL}chat`,
//     bnpl: `${apiBaseURL}payment`,
//     loan: `${apiBaseURL}payment`,
//     payment: `${apiBaseURL}payment`,
//     kyc: "http://54.254.156.32:52311",
//     live: `${apiBaseURL}livehosting`,
//   };

//   const tempURL = typeToBaseURL[type] || "";

//   let param;
//   if (index > -1) {
//     let payLoad = await encryptPayload(data, pemPublicKey);
//     param = { payload: payLoad };
//   } else param = data;

//     try {
//     const response = await axios.post(`${tempURL}/${url}`, param, {
//       headers: type === "kyc" ? headers.optionPlane : headers.option,
//     });
//     return response;
//   } catch (error: any) {
//     if (error?.response?.status === 401) {
//       alertMessage(ALERT_TITLES.ERROR, "Session Expired.");
//     } else
//       return {
//         status: error?.response?.status || 400,
//         message: error?.response?.data || "Something went wrong",
//       };
//   }
// };

// const alertMessage = (title: string, text: string) => {
//   const swalWithBootstrapButtons = Swal.mixin({
//     customClass: {
//       confirmButton: "btn btn-success",
//       cancelButton: "btn btn-danger",
//     },
//     buttonsStyling: false,
//   });

//   swalWithBootstrapButtons
//     .fire({
//       title: title,
//       text: text,
//       icon:
//         title === "Error!"
//           ? "error"
//           : title === "Success!"
//           ? "success"
//           : "warning",
//       confirmButtonText: "OK",
//       reverseButtons: true,
//     })
//     .then((result: any) => {
//       if (result.isConfirmed) {
//         window.location.replace("/login");
//       }
//     });
// };

// export const UserSignup = async (url: string, data: any) => {
//   let headers = refreshHeaderOptionToken();

//   axios
//     .post(`${apiBaseURL}/user/${url}`, data, headers.optionPlane)
//     .then(function (response) {
//       setItemWithObject("response", { status: "success", response: response });
//     })
//     .catch(function (error) {
//       setItemWithObject("response", {
//         status: "error",
//         response: error.response,
//         code: error?.response?.status,
//       });
//     });
// };

// export const UserLogin = (url: string, data: any) => {
//   let headers = refreshHeaderOptionToken();

//   axios
//     .post(`${apiBaseURL}/user/${url}`, data, headers.optionPlane)
//     .then(function (response) {
//       setItemWithObject("response", { status: "success", response: response });
//     })
//     .catch(function (error) {
//       setItemWithObject("response", {
//         status: "error",
//         response: error.response,
//         code: error?.response?.status,
//       });
//     });
// };

// export const PUT = (url: string, data: any, type: string) => {
//   let headers = refreshHeaderOptionToken();

//   let tempURL =
//     type === "user"
//       ? apiBaseURL + "user"
//       : type === "provider"
//       ? apiBaseURL + "serviceprovider"
//       : apiBaseURL + "order";

//   return axios(`${tempURL}/${url}`, {
//     method: "PUT",
//     headers: headers.option,
//     data,
//   });
// };

// export const DELETE = (url: string, data: any, type: string) => {
//   let headers = refreshHeaderOptionToken();

//   let tempURL =
//     type === "user"
//       ? apiBaseURL + "user"
//       : type === "provider"
//       ? apiBaseURL + "serviceprovider"
//       : apiBaseURL + "order";
//   return axios(`${tempURL}/${url}`, {
//     method: "DELETE",
//     headers: headers.option,
//     data,
//   });
// };